/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelRateHeaderLookup.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/rate-header-lookup";

export class AutogenModelRateHeaderLookup<RowType extends ModelRow> extends Endpoint<RowType, RowRateHeaderLookupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowRateHeaderLookup extends ModelRow<RowRateHeaderLookupFields> {
	constructor(values?: Partial<RowRateHeaderLookupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowRateHeaderLookupFields {
	company_id: string;
	currency: string;
	distance_um: string;
	id: string;
	ltl: string;
	method: string;
	mile_type: string;
	minimum_weight: number;
	minimum_weight_um: string;
	product: string;
	remark: string;
	weight_um: string;
}

